/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { DriverDtoModel, DriverDtoModelType } from "./DriverDtoModel"
import { DriverDtoModelSelector } from "./DriverDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  driver: DriverDtoModelType;
}

/**
 * DriverProfileDeletedDtoBase
 * auto generated base class for the model DriverProfileDeletedDtoModel.
 */
export const DriverProfileDeletedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('DriverProfileDeletedDto')
  .props({
    __typename: types.optional(types.literal("DriverProfileDeletedDto"), "DriverProfileDeletedDto"),
    /** Driver profile that was just deleted */
    driver: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => DriverDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class DriverProfileDeletedDtoModelSelector extends QueryBuilder {
  driver(builder: string | DriverDtoModelSelector | ((selector: DriverDtoModelSelector) => DriverDtoModelSelector) | undefined) { return this.__child(`driver`, DriverDtoModelSelector, builder) }
}
export function selectFromDriverProfileDeletedDto() {
  return new DriverProfileDeletedDtoModelSelector()
}

export const driverProfileDeletedDtoModelPrimitives = selectFromDriverProfileDeletedDto()
